import { LayoutTemplateLinkModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class LayoutTemplateLinkService extends ApiService<LayoutTemplateLinkModel> {
	constructor() {
		super('layouttemplate');
	}
}

export default new LayoutTemplateLinkService();
